import type { NotificationInboxMessage } from '@playcastdotio/Messaging';
import { emitNotificationInboxHint } from '../../../../coordinators/notifications/notificationInboxHint';

/**
 * The websocket handler is a local signal only. It does not call the
 * notification service; the coordinator owns the coalesced re-read.
 */
export function handleNotificationInboxMessage(_message: NotificationInboxMessage): void {
  emitNotificationInboxHint();
}
